import { HandleFormSave } from '../../../application';

export default class FormSaveService {
    async RequestData(event) {
        const data = await HandleFormSave(event);

        return data;
    }
}
